import { useForm, Controller } from "react-hook-form";
import Container from "../../componentes/Container";
import BarraDeNavegacao from "../../componentes/BarraDeNavegacao";
import {
  BotaoComTextoEIcone,
  GerenciadorDeMensagem,
} from "@digix-ui/componentes";
import { CampoDeTexto } from "../../componentes";
import { useHistory } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import "./styles.scss";
import { criarProjeto } from "./service/criarProjeto";

export interface ProjetoFormData {
  nome: string;
  idPrograma: number;
  descricao: string;
  dataInicio?: string;
  dataFim?: string;
  textoDeCiencia: string;
}

const CadastrarProjeto = () => {
  const history = useHistory();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ProjetoFormData>({
    defaultValues: {
      nome: "",
      idPrograma: 1,
      descricao: "",
      dataInicio: "",
      dataFim: "",
      textoDeCiencia: "",
    },
  });

  const { mutate } = useMutation({
    mutationFn: criarProjeto,
    onSuccess: () => {
      GerenciadorDeMensagem.criarMensagem({
        tipo: "sucesso",
        icone: "far fa-check-circle",
        titulo: "Tudo certo!",
        texto: "Projeto cadastrado com sucesso",
      });
      voltarParaListagemDeProjetos();
    }
  });

  function onSubmit(data: ProjetoFormData) {
    const payload = {
      ...data,
      idPrograma: Number(data.idPrograma),
    };

    mutate(payload);
  }

  const voltarParaListagemDeProjetos = () => {
    history.push("/gerenciar-locais-permissoes?aba=projetos");
  };

  return (
    <>
      <BarraDeNavegacao titulo="Criar projeto" comBotaoADireita={false} />
      <Container comFundo tamanhoDoContainer="grande">
        <form className="formulario" onSubmit={handleSubmit(onSubmit)}>
          <h2 className="cartao__titulo">Informações do projeto</h2>

          <div className="grade__linha u-margem-superior-media">
            <Controller
              name="nome"
              control={control}
              rules={{ required: "Nome do projeto é obrigatório" }}
              render={({ field }) => (
                <CampoDeTexto
                  {...field}
                  erro={errors.nome?.message}
                  label="Nome do projeto"
                  colunas="6"
                />
              )}
            />
            <Controller
              name="idPrograma"
              control={control}
              rules={{ required: "Programa é obrigatório" }}
              render={({ field }) => (
                <div className="campo-de-texto u-coluna-6">
                  <label className="campo-de-texto__rotulo">Programa</label>
                  <select
                    {...field}
                    className="campo-de-texto__input"
                    onChange={(e) => field.onChange(Number(e.target.value))}
                    value={field.value}
                  >
                    <option value="">Selecione</option>
                    <option value={1}>MS CIDADÃO CASA DA GENTE</option>
                  </select>
                  {errors.idPrograma && (
                    <span className="campo-de-texto__erro">
                      {errors.idPrograma.message}
                    </span>
                  )}
                </div>
              )}
            />
          </div>

          <div className="campo-de-texto--longo u-margem-superior-pequena">
            <Controller
              name="descricao"
              control={control}
              rules={{ required: "Descrição é obrigatória" }}
              render={({ field }) => (
                <CampoDeTexto
                  {...field}
                  erro={errors.descricao?.message}
                  label="Descrição"
                />
              )}
            />
          </div>

          <div className="grade__linha u-margem-superior-pequena">
            <Controller
              name="dataInicio"
              control={control}
              rules={{ required: "Data de início é obrigatória" }}
              render={({ field }) => (
                <CampoDeTexto
                  {...field}
                  value={field.value ?? ""}
                  tipo="date"
                  erro={errors.dataInicio?.message}
                  label="Data de início"
                  colunas="6"
                />
              )}
            />
            <Controller
              name="dataFim"
              control={control}
              rules={{ required: "Data de fim é obrigatória" }}
              render={({ field }) => (
                <CampoDeTexto
                  {...field}
                  value={field.value ?? ""}
                  tipo="date"
                  erro={errors.dataFim?.message}
                  label="Data de fim"
                  colunas="6"
                />
              )}
            />
          </div>

          <div className="campo-de-texto--longo u-margem-superior-media">
            <Controller
              name="textoDeCiencia"
              control={control}
              rules={{ required: "Texto de ciência é obrigatório" }}
              render={({ field }) => (
                <CampoDeTexto
                  {...field}
                  erro={errors.textoDeCiencia?.message}
                  label="Texto de ciência"
                />
              )}
            />
          </div> 

          <div className="formulario__botoes u-margem-top-grande">
            <BotaoComTextoEIcone
              tamanho="pequeno"
              cor="secundaria"
              tipo="button"
              icone="far fa-arrow-left"
              posicaoDoIcone="esquerda"
              onClick={voltarParaListagemDeProjetos}
            >
              Voltar
            </BotaoComTextoEIcone>

            <BotaoComTextoEIcone
              tamanho="pequeno"
              cor="sucesso"
              tipo="submit"
              icone="far fa-check"
              posicaoDoIcone="esquerda"
            >
              Salvar
            </BotaoComTextoEIcone>
          </div>
        </form>
      </Container>
    </>
  );
};

export default CadastrarProjeto;
